import type { VoidFunctionComponent } from 'react';

import LabeledCheckmark from '../../generic/LabeledCheckmark';
import { STANDARD_REPORT_OPTIONS } from '../constants';

import styles from './StandardOptions.module.less';

/**
 * Static options which are always included by FOSSA.
 *
 * Note that we need this wrapper div, since the parent is a flex container
 * which provides proper spacing between child elements.
 */
export const StandardOptions: VoidFunctionComponent = () => (
  <div>
    <h4 className={styles.heading}>Included by FOSSA</h4>
    <div className={styles.list}>
      {STANDARD_REPORT_OPTIONS.map((option) => (
        <LabeledCheckmark
          key={option.id}
          id={option.id}
          label={option.label}
          tooltip={option.tooltip}
          tooltipPlacement="left"
        />
      ))}
    </div>
  </div>
);
